import { render, staticRenderFns } from "./IconAppSchoolConfig.vue?vue&type=template&id=2107f558&scoped=true"
import script from "./IconAppSchoolConfig.vue?vue&type=script&lang=js"
export * from "./IconAppSchoolConfig.vue?vue&type=script&lang=js"
import style0 from "./IconAppSchoolConfig.vue?vue&type=style&index=0&id=2107f558&lang=css"
import style1 from "./IconAppSchoolConfig.vue?vue&type=style&index=1&id=2107f558&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2107f558",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2107f558')) {
      api.createRecord('2107f558', component.options)
    } else {
      api.reload('2107f558', component.options)
    }
    module.hot.accept("./IconAppSchoolConfig.vue?vue&type=template&id=2107f558&scoped=true", function () {
      api.rerender('2107f558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/iconApp/IconAppSchoolConfig.vue"
export default component.exports